import { VehicleKind } from "@/api-schema-enums";
import { VEHICLE_KIND_LABELS } from "@/common/helpers/vehicle-type-labels";
import i18next from "i18next";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

function getVehicleKindOptions(): { id: VehicleKind; name: string }[] {
  const lang = i18next.language === "de" ? "de" : "en";
  return Object.entries(VEHICLE_KIND_LABELS)
    .filter(([key]) => Object.values(VehicleKind).includes(key as VehicleKind))
    .map(([id, labels]) => ({ id: id as VehicleKind, name: labels[lang] }));
}

export class VehicleKindFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id: string = "vehicleKind";
  readonly labelSingular = "masterdata:VehicleKind";
  readonly labelPlural = "masterdata:VehicleKind";
  readonly placeholder = "masterdata:SelectVehicleKind";
  readonly searchPlaceholder = "masterdata:SearchVehicleKind";
  readonly emptyText = "masterdata:NoVehicleKindFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: getVehicleKindOptions(),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
